/**
 * Centralized query keys for custom models
 * This ensures consistency across all custom model queries and mutations
 */
export const CUSTOM_MODEL_QUERY_KEYS = {
  // Main list queries
  list: ['customModels'] as const,
  listWithPagination: (offset: number, limit: number) =>
    ['customModels', 'list', offset, limit] as const,

  // Individual model queries
  detail: (id: number) => ['customModels', 'detail', id] as const,
  data: (id: number) => ['customModels', 'data', id] as const,
  dataWithPagination: (id: number, offset: number, limit: number) =>
    ['customModels', 'data', id, offset, limit] as const,

  // Training related
  training: (id: number) => ['customModels', 'training', id] as const,
  rounds: (id: number) => ['customModels', 'rounds', id] as const,

  // General prefix for invalidating all custom model queries
  all: ['customModels'] as const
} as const;
